globalThis.googleMapsLoadedCallback = function() {
  /**
   * 2023-01-19 — google maps pushed a change which required this callback to be defined,
   * even though we don't need it because we don't load google maps asynchronously, so
   * this is here and does nothing so that it's available.
   * */
}